import { Delete, Edit } from "@mui/icons-material";
import {
    Alert,
    Button,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
    ProgressStyled,
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { useEffect, useState } from "react";
import { AvaterController } from "../../Layouts/AvaterController";
import { saveObj } from "../../Redux/SaveObjToUpdate/SaveSlice";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {
    contractorsReset,
    DeleteContractorAction,
    GetAllContractors,
    SearchONContractors,
} from "../../Redux/ContractorSlice/ContractorSlice";
import { DeleteModal } from "../../Components/Modal/Modals";
import { toast } from "react-toastify";

const AllContractors = () => {
    const dispatch = useDispatch();
    const { contractors, isLoading, isSuccess } = useSelector(
        (state) => state.contractors
    );
    const contractorsData = contractors?.data?.data || [];
    const contractorPag = contractors?.data;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    // Delete Contractor Confirm
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    const [tableId, setTableId] = useState(null);

    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };
    const CallNotificationMethod = async () => {
        await toast.success(" Contractor deleted success");
        await GetContractors()
        await dispatch(contractorsReset());

    }
    const DeleteRow = async () => {
        handleClose();
        await dispatch(
            DeleteContractorAction({
                contractor_id: data.id,
            })
        );
        await CallNotificationMethod();
        await setTableId(data.id);

    };
    const handelDeleteContractor = async (data) => {
        handleOpen(data);
    };

    // Filter By Fields Variables
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [status, setStatus] = useState("");
    const [entity, setEntity] = useState("");
    const [license, setLicense] = useState("");
    const [initial, setInitial] = useState("");
    const [state, setState] = useState("");

    const searchObj = {
        name,
        address,
        status,
        entity,
        license,
        initial,
        state,
    };

    const handelFilterAction = async (object_search = null) => {
        await dispatch(
            SearchONContractors({ ...object_search, paginate: rowsPerPage })
        );
        await dispatch(contractorsReset());
    };

    const handelResetData = () => {
        setName("");
        setAddress("");
        setStatus("");
        setEntity("");
        setLicense("");
        setInitial("");
        setState("");
        handelFilterAction();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        const callSearchAction = async () => {
            await dispatch(
                SearchONContractors({
                    ...searchObj,
                    paginate: rowsPerPage,
                    page: newPage + 1,
                })
            );
            await dispatch(contractorsReset());
        };
        callSearchAction();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
        const callSearchAction = async () => {
            await dispatch(
                SearchONContractors({
                    ...searchObj,
                    paginate: event.target.value,
                })
            );
            await dispatch(contractorsReset());
        };
        callSearchAction();
    };

    function inputKeyUp(e) {
        e.which = e.which || e.keyCode;
        if (e.which === 13) {
            handelFilterAction(searchObj);
        }
    }

    const GetContractors = async () => {
        await dispatch(GetAllContractors());
        await dispatch(contractorsReset());
    };
    useEffect(() => {
        GetContractors();
    }, []);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <TableContainerStyled component={Paper}>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell style={{ padding: "5px" }}>
                                    Filter By :
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="name"
                                            name="name"
                                            label="Name"
                                            value={name}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setName(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="address"
                                            name="address"
                                            label="Address"
                                            value={address}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setAddress(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">
                                                Status
                                            </InputLabel>
                                            <Select
                                                id="status"
                                                name="status"
                                                label="Status"
                                                value={status}
                                                onChange={(e) =>
                                                    setStatus(e.target.value)
                                                }
                                            >
                                                <MenuItem value="2">
                                                    Inactive
                                                </MenuItem>
                                                <MenuItem value="1">
                                                    Active
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="entity"
                                            name="entity"
                                            label="Entity"
                                            value={entity}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setEntity(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="license"
                                            name="license"
                                            label="License"
                                            value={license}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setLicense(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="initial"
                                            name="initial"
                                            label="Initial"
                                            value={initial}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setInitial(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="state"
                                            name="state"
                                            label="State"
                                            value={state}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setState(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell></TableCell>

                                <TableCell
                                    style={{ padding: "5px" }}
                                    align="center"
                                >
                                    <Grid container coulmns={12}>
                                        <Button
                                            style={{ marginBottom: "5px" }}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={(e) =>
                                                handelFilterAction(searchObj)
                                            }
                                        >
                                            <FilterAltIcon></FilterAltIcon>
                                        </Button>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="error"
                                            onClick={(e) => handelResetData()}
                                        >
                                            <RestartAltIcon></RestartAltIcon>
                                        </Button>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        </TableHeadStyled>
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell width={200}>Name </TableCell>
                                <TableCell width={250}>Address</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Entity</TableCell>
                                <TableCell>License</TableCell>
                                <TableCell>Initial</TableCell>
                                <TableCell>State</TableCell>
                                <TableCell>Expiry Date</TableCell>
                                <TableCell align="center"> ACTIONS </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {contractorsData?.map((key, index) => (
                                <TableRowStyled key={key.id}>
                                    <TableCellStyle>
                                        {/* {rowsPerPage * page + index + 1} */}
                                        {index + 1}
                                    </TableCellStyle>

                                    <TableCellStyle>{key.name}</TableCellStyle>
                                    <TableCellStyle>
                                        {key.address}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key.status}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key.entity}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key.license}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key.initial ? key.initial : "___"}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {/* {key?.states[0]?.name
                                            ? key?.states[0]?.name
                                            : "___"} */}
                                        {key?.states[0]?.name}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key.expiry_date}
                                    </TableCellStyle>

                                    <TableCellStyle align="center">
                                        <IconButton>
                                            <Link to={`edit=${key.id}`}>
                                                <Edit color="primary" />
                                            </Link>
                                        </IconButton>
                                        <IconButton
                                            onClick={() =>
                                                handelDeleteContractor(key)
                                            }
                                        >
                                            {tableId === key.id && (
                                                <ProgressStyled>
                                                    <CircularProgress
                                                        size={30}
                                                        color="error"
                                                    />
                                                </ProgressStyled>
                                            )}

                                            <ProgressStyled>
                                                <Delete color="error" />
                                            </ProgressStyled>
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>

                        {contractorPag?.total >= 20 && (
                            <TablePagination
                                rowsPerPageOptions={[
                                    20,
                                    50,
                                    100,
                                    { label: "All", value: -1 },
                                ]}
                                colSpan={12}
                                count={contractorPag?.total}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )}
                    </Table>

                    {contractorPag?.total < 1 && (
                        <Alert icon={false} severity="error">
                            <Typography
                                variant="h6"
                                className="MuiTypography-alignCenter"
                            >
                                There are no items, please try again
                            </Typography>
                        </Alert>
                    )}
                    {/* delete modal  */}
                    <DeleteModal
                        open={open}
                        close={handleClose}
                        title={data?.name}
                        onClick={DeleteRow}
                        loading={isLoading}
                    />
                </TableContainerStyled>
            )}
        </>
    );
};

export default AllContractors;
